<template>
    <auth-card-template>
        <card-auth>
            <h4 class="font-family-title font-weight-bold text-success text-center mb-6">Confime que essa é a sua conta</h4>
            <div class="text-center">
                <p>
                    Insira o código de 6 digitos gerado pelo seu aplicativo de autenticação de dois fatores.
                </p>
            </div>

            <div v-show="errorMessage" class="alert alert-danger mb-6" v-html="errorMessage"></div>

            <form @submit="verify2FA($event)">
                <form-code
                    @verification-code="getCode"
                    :error="formErrors.code"
                />
                <div class="form-buttons text-center">
                    <button-form  type="submit" ref="btnVerifyCode" theme="success" class="btn-lg px-8">Confirmar</button-form>
                </div>
            </form>
        </card-auth>
    </auth-card-template>
</template>

<script>
    import { mapActions }   from 'vuex'
    import ErrorService     from '@/services/error.service'
    import ButtonForm       from '@/components/atoms/ButtonForm'
    import FormCode         from '@/components/molecules/FormCode'
    import CardAuth         from '@/components/organisms/CardAuth'
    import AuthCardTemplate from '@/components/templates/AuthCardTemplate'

    export default {
        components: {
            ButtonForm,
            FormCode,
            CardAuth,
            AuthCardTemplate
        },
        data() {
            return {
                formData: {
                    email:'',
                    password:'',
                    recaptcha_token:''
                },
                formErrors: {},
                errorMessage: "",
                verificationCode: [],
                provider: null,
                verificationToken2FA: null,
            }
        },
        beforeRouteEnter(to, from, next)
        {
            const userAuthentication = JSON.parse(localStorage.getItem('user_authetication'));
            const provider = to.query.provider

            if (userAuthentication)
            {
                localStorage.removeItem('user_authetication')

                next((vm) => {
                    vm.formData.email = userAuthentication.email;
                    vm.formData.password = userAuthentication.password;
                    vm.formData.recaptcha_token = userAuthentication.recaptcha_token;
                });
            }
            else if (provider)
            {
                next((vm) => {
                    vm.provider = provider;
                    vm.verificationToken2FA = to.query.verificationToken2FA;
                    if(to.query.errorMessage)
                        vm.errorMessage = to.query.errorMessage;
                });
            }
            else
                next('/auth/login');
        },
        methods: {
            ...mapActions({
                loginUser: 'user/login',
                showErrorAlert: 'alert/error'
            }),

            /**
             * Faz o login novamente.
             */
            verify2FA(e)
            {
                e.preventDefault();

                if (this.verificationCode.length == 6)
                {
                    this.$refs.btnVerifyCode.loadingFocus();

                    this.formErrors = {};
                    this.errorMessage = '';
                    
                    // Verificar se é um login normal (email e password)
                    if (!this.provider)
                    {
                        const { email, password, recaptcha_token} = this.formData;

                        const loginData =  {
                            email,
                            password,
                            captcha: recaptcha_token,
                            code2fa: this.verificationCode.join('')
                        };

                        this.loginUser(loginData)
                            .then(response => {

                                // Verificação de telefone
                                if (response.data.data.phoneVerification) {
                                    this.$router.push({ path: '/auth/verification/phone', query: { token: response.data.data.token } });
                                    return;
                                }

                                if (response.data.data.partnerSurvey) {
                                    window.location.href = "/become-partner";
                                }

                                let redirectUrl = "/";

                                if (this.$route.query.redirect) {
                                    redirectUrl = this.killXSS(this.$route.query.redirect);
                                }

                                window.location.href = redirectUrl;
                            })
                            .catch(error => {
                                const status = error.response.status || 0;

                                if (status === 422) {
                                    ErrorService.handleFormError(error, this);
                                }
                                else if (status >= 400 && typeof error.response.data.message !== 'undefined') {
                                    this.errorMessage = error.response.data.message;
                                }
                                else {
                                    this.showErrorAlert(error);
                                }

                                this.$refs.btnVerifyCode.setLoading(false)
                            })
                    }
                    else {
                        // Login social
                        window.location.replace(`/auth/${this.provider}?verificationToken2FA=${this.verificationToken2FA}&code2fa=${this.verificationCode.join('')}`);
                    }    
                }
            },

            getCode(payload) {
                this.verificationCode = payload.verificationCode;
            }
        },
    }
</script>